export default __webpack_public_path__ + "static/media/shoes_congo.2d454fa5.svg";